import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-21001f4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block menu-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-logo",
    src: _imports_0
  })
], -1))
const _hoisted_3 = {
  key: 0,
  class: "button-container"
}
const _hoisted_4 = { class: "dropdown-trigger" }
const _hoisted_5 = { class: "icon-new" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-new-button" }, "Novo", -1))
const _hoisted_7 = {
  class: "dropdown-menu",
  name: "menu-new",
  id: "menu-new",
  role: "menu"
}
const _hoisted_8 = { class: "dropdown-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_12 = { class: "menu smart-city" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, " Smart City ", -1))
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = {
  class: "menu-item",
  style: { display: 'none'}
}
const _hoisted_17 = { class: "icon" }
const _hoisted_18 = { class: "menu gateway" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, " Gateway ", -1))
const _hoisted_20 = { class: "icon" }
const _hoisted_21 = { class: "icon" }
const _hoisted_22 = {
  key: 1,
  class: "menu alarmes"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, " Alarmes ", -1))
const _hoisted_24 = { class: "icon" }
const _hoisted_25 = { class: "icon" }
const _hoisted_26 = {
  ref: "menuBilling",
  class: "menu billing"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, " Faturamento ", -1))
const _hoisted_28 = { class: "icon" }
const _hoisted_29 = { class: "icon" }
const _hoisted_30 = {
  ref: "menuAcessos",
  class: "menu acessos"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, " Acessos ", -1))
const _hoisted_32 = { class: "icon" }
const _hoisted_33 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.hasCreatePermission)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["dropdown", { 'is-active': _ctx.isOptions}])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                ref: "button",
                class: "button is-new-button",
                "aria-haspopup": "true",
                "aria-controls": "menu-new",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showButtonOptions && _ctx.showButtonOptions(...args)))
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-plus is-new-button",
                    size: "xl"
                  })
                ]),
                _hoisted_6
              ], 512)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.newStructure && _ctx.newStructure(...args)))
                }, " Estrutura "),
                (_ctx.route.name == 'Structures')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "dropdown-item",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.newSensor && _ctx.newSensor(...args)))
                    }, " Sensor "))
                  : _createCommentVNode("", true),
                _hoisted_9,
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.newUser && _ctx.newUser(...args)))
                }, " Usuário "),
                (_ctx.route.name == 'Triggers')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.newTrigger && _ctx.newTrigger(...args)))
                      }, " Gatilho ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", null, [
        _hoisted_13,
        _createElementVNode("div", {
          class: _normalizeClass(["menu-item", { active: _ctx.route.name == 'Structures' }])
        }, [
          _createVNode(_component_router_link, {
            to: `/dashboard/structure/${_ctx.root}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_14, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-home" })
              ]),
              _createTextVNode(" Home ")
            ]),
            _: 1
          }, 8, ["to"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["menu-item", { active: _ctx.route.name == 'Monitor' }])
        }, [
          _createVNode(_component_router_link, { to: "/dashboard/monitor" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-tv" })
              ]),
              _createTextVNode(" Monitoramento ")
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("a", null, [
            _createElementVNode("span", _hoisted_17, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-gear" })
            ]),
            _createTextVNode(" Configurações ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", null, [
        _hoisted_19,
        _createElementVNode("div", {
          class: _normalizeClass(["menu-item", { active: _ctx.route.name == 'Endpoints' }])
        }, [
          _createVNode(_component_router_link, { to: "/dashboard/endpoint" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_20, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-tower-broadcast" })
              ]),
              _createTextVNode(" Endpoints ")
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["menu-item", { active: _ctx.route.name == 'Sensors' }])
        }, [
          _createVNode(_component_router_link, { to: "/dashboard/sensor" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_21, [
                _createVNode(_component_font_awesome_layers, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-cloud-sun-rain",
                      transform: "shrink-6 up-6 left-7"
                    }),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-wifi",
                      transform: "shrink-6 up-6 right-5"
                    }),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-temperature-half",
                      transform: "shrink-6 down-6 left-5"
                    }),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-snowflake",
                      transform: "shrink-6 down-6 right-7"
                    })
                  ]),
                  _: 1
                })
              ]),
              _createTextVNode(" Sensores ")
            ]),
            _: 1
          })
        ], 2)
      ])
    ]),
    (_ctx.isMaster || _ctx.isSmartAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", null, [
            _hoisted_23,
            _createElementVNode("div", {
              class: _normalizeClass(["menu-item", { active: _ctx.route.name == 'Triggers' }])
            }, [
              _createVNode(_component_router_link, { to: "/dashboard/trigger" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_24, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-gear" })
                  ]),
                  _createTextVNode(" Configuração ")
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["menu-item", { active: _ctx.route.name == 'Alarms' }])
            }, [
              _createVNode(_component_router_link, { to: "/dashboard/alarm" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_25, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-bell" })
                  ]),
                  _createTextVNode(" Alarmes Ativos ")
                ]),
                _: 1
              })
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", null, [
        _hoisted_27,
        _createElementVNode("div", {
          class: _normalizeClass(["menu-item", { active: _ctx.route.name == 'Billing' }])
        }, [
          _createVNode(_component_router_link, { to: "/dashboard/billing/sensors" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_28, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-satellite-dish" })
              ]),
              _createTextVNode(" Sensores ")
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["menu-item", { active: _ctx.route.name == 'Report' }])
        }, [
          _createVNode(_component_router_link, { to: "/dashboard/billing/report" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_29, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-file-invoice-dollar" })
              ]),
              _createTextVNode(" Relatório ")
            ]),
            _: 1
          })
        ], 2)
      ])
    ], 512),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", null, [
        _hoisted_31,
        _createElementVNode("div", {
          class: _normalizeClass(["menu-item", { active: _ctx.route.name == 'Users' }])
        }, [
          _createVNode(_component_router_link, { to: "/dashboard/user" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_32, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-user" })
              ]),
              _createTextVNode(" Usuários ")
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["menu-item", { active: _ctx.route.name == 'Permissions' }]),
          style: {"display":"none"}
        }, [
          _createVNode(_component_router_link, { to: "/dashboard/permission" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_33, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-shield-halved" })
              ]),
              _createTextVNode(" Permissões ")
            ]),
            _: 1
          })
        ], 2)
      ])
    ], 512)
  ]))
}